<template>
  <div class="searchPage" :class="{'searchPage_navigation': isFengChaoShow}">
    <zdy-nav @back="back" leftTitle="搜索"></zdy-nav>
    <div class="searchPage-content">
      <div class="search-box">
        <div class="left-box">
          <img src="@/assets/searchIcon.svg" alt="">
          <input @input="onchangeSearch" type="text" v-model="searchVal" ref="searchInput" @keyup.enter="toSearch" @blur="toSearch" placeholder="搜索">
          <Icon type="md-close-circle" v-if="searchVal" @click="clearInput"/>
        </div>
        <div 
          class="right-btn" 
          @click="toAllssue" 
        >取消</div>
      </div>
      <div style="position: relative;height: calc(100vh - 104px)">
        <!-- v-if="searchLoading" -->
        <Spin class="searchLoading" v-if="searchLoading"  fix>
          <img style="width: 32px;" class="demo-spin-icon-load" src="@/assets/loading.webp" alt="">
        </Spin>
        <template v-if="searchList.length && !searchLoading">
          <cube-scroll  style="height: calc(100vh - 104px)" :data="searchList">
            
            <div 
              class="content-box" 
              v-for="(item, index) in searchList" :key="index"
            >
              <div class="list-title"> 
                <div class="blue-line"></div>
                {{ item.typeName }}
              </div>
              <div v-for="(val, i) in item.aiQuestionList" :key="`val${i}`" >
                <div 
                  class="line-box" 
                  @click="toDetails(val)"
                  @touchstart="handleMouseEnter(val.questionId)"
                  :style="val.questionId === classIndex ? 'backgroundColor: #F7F7F7' : ''"
                >
                  <span class="left-span" v-html="val.questionNameTitle"></span>
                  <img class="right-span" src="@/assets/jiantouRight2.svg" alt="">
                </div>
                <div v-if="item.aiQuestionList.length-1 != i" class="borderBottom"></div>
              </div>
            </div>
          </cube-scroll>
        </template>
        <template v-if="!searchList.length && isSearch && !searchLoading">
          <div class="noData">
            <img src="@/assets/noSearch.png" alt="">
            未找到相关问题
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { setStore, getStore, removeStore } from '@/utils/store'
import { debounce } from 'lodash'
export default {
  data() {
    return {
      searchLoading: false,
      classIndex: -1,
      oldSearchVal: '',
      searchVal: '',
      searchList: [],
      panelList: [
        {
          name: '123',
          list: []
        }
      ],
      isSearch: false,
      onchangeSearch: ''
    }
  },
  computed: {
    isFengChaoShow() {
      return this.$store.state.isFengChaoShow
    },
  },
  created() {
    this.onchangeSearch = debounce(this.toSearch, 350)
    if (getStore({name: 'searchPageVal', type: 'session'})) {
      this.searchVal = getStore({ name: 'searchPageVal', type: 'session' })
      this.toSearch()
    }
    console.log(this.$refs.searchInput)
  },
  mounted() {
    this.$refs.searchInput.focus()
  },
  methods: {
    clearInput() {
      this.searchVal = ''
      this.searchList = []
      this.isSearch = false
    },
    // 鼠标移入
    handleMouseEnter(val) {
      this.classIndex = val;
      setTimeout(() => {
        this.classIndex = -1
      }, 1000);
    },
    back() {
      this.$router.go(-1);
    },
    close() {
      this.$cjc.closeWebView();
    },
    // 搜索
    async toSearch() {
      console.log('搜索')
      if (this.searchVal === this.oldSearchVal || !this.searchVal) return
      this.isSearch = true
      this.searchLoading = true
      const res = await this.$store.dispatch('searchQuestion', { question: this.searchVal })
      this.oldSearchVal = this.searchVal
      if (res.data.status === 1000) {
        this.searchList = res.data.result
        this.searchList.map(item => {
          if (item.aiQuestionList && item.aiQuestionList.length) {
            item.aiQuestionList.map(val => {
              val.questionNameTitle = this.highlightKeyword(val.questionName, this.searchVal)
            })
          }
        })
        console.log(this.searchList)
      } else {
        this.$createToast({
          type: 'warn',
          time: 1000,
          txt: res.data.msg
        }).show()
      }
      this.searchLoading = false
    },
    highlightKeyword(text, keyword) {
      const regex = new RegExp(keyword, 'gi'); // 'gi' 参数表示全局匹配，不区分大小写  
      return text.replace(regex, '<span style="color: #008CFF;">$&</span>');
    },
    toDetails(item) {
      setStore({name:'searchPageVal', content:this.searchVal, type:'session'})
      if (item.answerType === 1) {
        this.$router.push({ name: 'answerPage', params: item });
      } else {
        window.open(item.answer);
      }
    },
    toAllssue () {
      this.$router.replace({name: 'allIssue'})
    },
  },
  beforeRouteLeave (to, from, next) {
    console.log('to', to)
    console.log('from', from)
    if (to.name === 'allIssue') {
      console.log('removeStore')
      removeStore({name: 'searchPageVal', type: 'session'})
    }
    next()
  }
}
</script>

<style lang="scss">
.searchPage_navigation {
  .searchPage-content {
    margin-top: 0px !important;
    height: 100vh !important;
  }
}
.searchPage {
  
  .searchLoading{
    position: absolute;
    height: 100%;
    align-items: center;
    .ivu-spin-main{
      top:130px
    }
  }
  .searchPage-content {
    background-color: #F0F2F3;
    margin-top: 44px;
    height: calc(100vh - 44px);
    overflow-y: auto;
    .search-box {
      width: 100vw;
      padding: 12px 0 12px 12px;
      background: #F0F2F3;
      display: flex;
      align-items: center;
      .left-box{
        width: calc(100vw - 66px);
        height: 36px;
        background: #FFFFFF;
        border-radius: 10px;
        padding: 8px 10px;
        display: flex;
        align-items: center;
        position: relative;
        .ivu-icon-md-close-circle{
          position: absolute;
          right: 12px;
          color: #A6A6A6;
          font-size: 16px;
        }
        img{
          margin-right: 4px;
        }
        input{
          width: calc(100vw - 108px);
        }
        input::placeholder{
          color: #BDBDBD;
        }
      }
      .right-btn{
        margin-left: 12px;
        font-size: 13px;
        color: #1A1A1A;
      }
    }
    .noData{
      height: calc(100vh - 66px - 44px);
      display: flex;
      align-items: center;
      flex-direction: column;
      font-size: 14px;
      color: #A6A6A6;
      line-height: 14px;
      margin-top: 6px;
      padding-top: 135px;
      img{
        width: 128px;
      }
    }
    .cube-scroll-list-wrapper{
      padding: 0 12px;
    }
    .content-box{
      background: #FFFFFF;
      border-radius: 10px;
      margin-bottom: 12px;
      overflow: hidden;
      .list-title{
        padding: 6px 12px 5px 12px;
        font-size: 15px;
        line-height: 21px;
        display: flex;
        align-items: center;
        color: #1A1A1A;
        font-weight: bold;
        padding: 12px;
        border-bottom: 1px solid #F2F2F2;
        .blue-line{
          width: 2px;
          height: 12px;
          background: #008CFF;
          border-radius: 1px;
          margin-right: 4px;
        }
      }
      .line-box{
        background-color: #FFFFFF;
        padding: 14px 12px 13px 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left-span{
          font-size: 14px;
          color: #1A1A1A;
          line-height: 21px;
          word-break: break-all;
          word-wrap: break-word;
        }
      }
      .borderBottom{
        width: 327px;
        height: 1px;
        background: #F2F2F2;
        margin: 0 12px;
      }
    }
    .content-box:last-child{
      margin-bottom: 34px;
    }
  }
}</style>